import { api } from './client'

const objectService = {
  createObject: async (typeId, fields) => {
    const resp = await api.post(`/objects/${typeId}`, { fields })
    return resp.data
  },

  updateObject: async (typeId, itemId, fields) => {
    const resp = await api.put(`/objects/${typeId}/${itemId}`, { fields })
    return resp.data
  },
}

export default objectService
